export const Prices = [
  {
    _id: 0,
    name: "Any",
    array: [0, 99999999],
  },
  {
    _id: 1,
    name: "₹0 to ₹99",
    array: [0, 99],
  },
  {
    _id: 2,
    name: "₹100 to ₹199",
    array: [100, 199],
  },
  {
    _id: 3,
    name: "₹200 to ₹399",
    array: [200, 399],
  },
  {
    _id: 4,
    name: "₹400 to ₹799",
    array: [400, 799],
  },
  {
    _id: 5,
    name: "More than ₹799",
    array: [799, 9999999],
  },
];
